import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManageShiftsEditPage } from './manage-shifts-edit.page';

const routes: Routes = [
  {
    path: '',
    component: ManageShiftsEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageShiftsEditPageRoutingModule {}
